import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createTextVNode as _createTextVNode, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a77a702a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "d-flex align-items-center" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_inline_svg = _resolveComponent("inline-svg");
    return (_openBlock(), _createElementBlock("div", _mergeProps({
        class: `upload-file-container ${_ctx.isDragActive ? 'drag-active' : ''}`
    }, _ctx.getRootProps()), [
        _createElementVNode("input", _normalizeProps(_guardReactiveProps(_ctx.getInputProps())), null, 16 /* FULL_PROPS */),
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_inline_svg, {
                src: "media/icons/custom/upload-green.svg",
                class: "me-2"
            }),
            (_ctx.file.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.file[0]['name']), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "placeholder", {}, () => [
                        _createTextVNode(" Upload file ")
                    ], true)
                ]))
        ])
    ], 16 /* FULL_PROPS */));
}
